<div class="game-screen">
  <div class="glow green"></div>
  <div class="glow purple"></div>

  <div class="game-header">
    <div class="btn-wrapper">
      <button class="back-button" (click)="goBack()">
        <img src="assets/images/backArrow.png" alt="Arrow back" />
      </button>
      <h2>{{ gameName }}</h2>
    </div>
    <button class="restart-button" (click)="restartGame()">↻ Restart</button>
  </div>

  <div class="game-frame">
    <ng-container *ngIf="gameUrl; else fallback">
      <iframe
        id="game-frame"
        [src]="gameUrl"
        width="100%"
        height="702"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </ng-container>

    <ng-template #fallback>
      <img [src]="gameImage" [alt]="gameName" />
    </ng-template>
  </div>
</div>

<app-modal
  [isOpen]="isModalOpen"
  [icon]="'assets/images/back.png'"
  [title]="'Are you sure you want to quit?'"
  [text]="'All progress will be lost and cannot be recovered.'"
  [primaryBtnText]="'Continue Playing'"
  [secondaryBtnText]="'Quit Game'"
  (primaryClick)="resumeGame()"
  (secondaryClick)="quiteGame()"
  (close)="resumeGame()"
></app-modal>

<app-modal
  [isOpen]="isModalReadyToPlayOpen"
  [icon]="'assets/images/coin.png'"
  [title]="'Ready to play?'"
  [text]="modalText"
  [primaryBtnText]="'Play Now'"
  [secondaryBtnText]="'Cancel'"
  (primaryClick)="startGame()"
  (secondaryClick)="closeReadyToPlayModal()"
  (close)="closeReadyToPlayModal()">
</app-modal>
